export enum CommunityMemberRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}

export namespace CommunityMemberRole {
  export function getDisplayName(role?: CommunityMemberRole): string {
    switch (role) {
      case CommunityMemberRole.ADMIN:
        return 'APP.COMMUNITIES.ADMIN';
      case CommunityMemberRole.MEMBER:
        return 'APP.COMMUNITIES.MEMBER';
      default:
        return '';
    }
  }
}
